module.exports = __webpack_public_path__ + "static/media/flight11.7ff0fd63.png";